export default function highlightParts(string, substring) {
    const index = string.toLocaleLowerCase().indexOf(substring.toLocaleLowerCase())
    if (index === -1) return [string, "", ""]
    const length = substring.length
    return [string.slice(0, index), string.slice(index, index+length), string.slice(index+length, string.length)]
}